import { FunctionComponent, useState } from "react";

import { PermissionCheck } from "@/components";

import { PermissionRoles } from "@/enum";

import { ButtonColor, ButtonSize } from "@/components/Button/types";
import { Button } from "@/components/Button/Button";

import { RepliesTable } from "./components/RepliesTable";
import { CreateReplyTemplateModal } from "./components/CreateReplyTemplateModal";

export const Replies: FunctionComponent = () => {
	const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);

	return (
		<div className="sm:block flex flex-col items-start justify-between mb-6">
			<div className="flex flex-row justify-between w-full mb-4">
				<div className="flex flex-col items-start justify-start grow">
					<div className="text-md mb-2 whitespace-nowrap">Reply Templates</div>
					<div className="text-sm text-text-meta">
						Manage reply templates that can be used in your lists.
					</div>
				</div>
				<div className="flex items-end justify-end mb-8">
					<div className="flex justify-end">
						<PermissionCheck requiredPermissions={[PermissionRoles.TEMPLATES]}>
							<Button
								color={ButtonColor.ACTION}
								size={ButtonSize.S}
								testId="new-prompt-button"
								title={"Create new Reply Template"}
								onClick={() => setIsCreateModalOpen(true)}
							/>
						</PermissionCheck>
					</div>
				</div>
			</div>
			{<RepliesTable />}
			{isCreateModalOpen && (
				<CreateReplyTemplateModal isOpen={isCreateModalOpen} setIsOpen={setIsCreateModalOpen} />
			)}
		</div>
	);
};
